import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { getToken } from '@/common/cookie';
import errorCode from './errorCode'

// document.cookie = 'userInfo={%22id%22:%22ac8c5b85c3614713aaba39bf4303d571%22%2C%22password%22:%22e1adc3949ba59abbe56e057f2f883e%22%2C%22unitCodeId%22:%22d9de16f0d23b43f3b0824bb077f6f9cb%22%2C%22company%22:%22compney%22%2C%22phone%22:%22123%22%2C%22userName%22:%22user%22}';
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers['cookie'] = 'XDEBUG_SESSION'
// 创建axios实例
var loading;
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: location.origin + '/api',
  // 超时
  timeout: 90000

})
// request拦截器
service.interceptors.request.use(config => {
  const tokenGet = getToken();
  // loading=Loading.service({
  //   lock:true,
  //   text:"请求数据中..请耐心等待..",
  //   background:'rgba(0,0,0,0.7)'
  // })
  config.headers['accessToken'] = tokenGet;
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // loading.close();
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const message = errorCode[code] || res.data.msg || errorCode['default']
  if (code == '00002') {
    MessageBox.confirm(
      '登录状态已过期，您可以继续留在该页面，或者重新登录',
      '系统提示',
      {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(() => {
      location.reload()
    })
  } else if (code != '00000') {
    Message({
      message: message,
      type: 'error'
    })
    // return Promise.reject(new Error(message))
  }
  return res.data
},
  error => {
    console.log('err' + error)
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
